export default "__VITE_ASSET__WFQzACHD__"